import { render, staticRenderFns } from "./DataTablePaginator.vue?vue&type=template&id=0d6b44d1&scoped=true&"
import script from "./DataTablePaginator.vue?vue&type=script&lang=ts&"
export * from "./DataTablePaginator.vue?vue&type=script&lang=ts&"
import style0 from "./DataTablePaginator.vue?vue&type=style&index=0&id=0d6b44d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b44d1",
  null
  
)

export default component.exports